import { DatosReporte } from '../core/reporte';

export interface FormatoReporteTgr extends DatosReporte {
    anio: boolean;
}

export interface DeudaVigenteTgr {
    folio: string;
    fechaVencimiento: string;
    deudaNeta: number;
    reajuste: number;
    interes: number;
    multa: number;
    total: number;
}

const REPORTE_DEUDAS_VIGENTES: FormatoReporteTgr = {
    tituloReporte: 'Deudas Vencidas TGR',
    subtituloReporte: 'Deudas vencidas informadas por la Tesorería General de la República.',
    icono: 'pi pi-wallet',
    anio: false,
    tablas: [
        {
            datos: 'deudas',
            titulo: 'Deudas Vencidas',
            subtitulo: 'Detalle de las obligaciones vigentes del contribuyente.',
            columnas: [
                { nombre: 'folio', titulo: 'Folio' },
                { nombre: 'fechaVencimiento', titulo: 'Fecha de vencimiento', formato: 'fecha' },
                { nombre: 'deudaNeta', titulo: 'Deuda neta', formato: 'moneda', clase: 'text-right' },
                { nombre: 'reajuste', titulo: 'Reajuste', formato: 'moneda', clase: 'text-right' },
                { nombre: 'interes', titulo: 'Interés', formato: 'moneda', clase: 'text-right' },
                { nombre: 'multa', titulo: 'Multa', formato: 'moneda', clase: 'text-right' },
                { nombre: 'total', titulo: 'Total', formato: 'moneda', clase: 'text-right' }
            ]
        }
    ]
};

const REPORTE_CONVENIOS_VIGENTES: FormatoReporteTgr = {
    tituloReporte: 'Convenios Vigentes',
    subtituloReporte: '',
    anio: false,
    tablas: [
        {
            datos: 'convenios',
            titulo: 'Convenios Vigentes',
            subtitulo: '',
            columnas: [
                {nombre: 'nro', "titulo": 'N°'},
                {nombre: 'nroResulucion', "titulo": 'N° De Resolución'},
                {nombre: 'fechaResolucion', "titulo": 'Fecha Resolución'},
                {nombre: 'tipoPago', "titulo": 'Tipo Pago'},
                {nombre: 'nroCuotas', "titulo": 'N° Cuotas'},
                {nombre: 'nroDeudas', "titulo": 'N° Deudas'},
                {nombre: 'saldoNeto', "titulo": 'Salgo Neto Actual'}
            ]
        }
    ]
}

const REPORTE_DIN_PAGADOS: FormatoReporteTgr = {
    tituloReporte: 'DIN Pagados',
    visibleEnMenu: false,
    subtituloReporte: 'Pagos de formularios 15 y 17 en la Cartola Fiscal de TGR.',
    icono: 'pi pi-file-check',
    anio: false,
    tablas: [{
        datos: 'pagos',
        titulo: 'DIN Pagados',
        subtitulo: 'Pagos voluntarios registrados en TGR durante el período disponible en la cartola.',
        columnas: [
            { nombre: 'formulario', titulo: 'Formulario' },
            { nombre: 'folio', titulo: 'Folio' },
            { nombre: 'fechaVencimiento', titulo: 'Fecha de vencimiento' },
            { nombre: 'fechaPago', titulo: 'Fecha de pago' },
            { nombre: 'montoPagado', titulo: 'Total pago', formato: 'moneda', clase: 'text-right' }
        ]
    }]
};

const REPORTE_DIN_PENDIENTES: FormatoReporteTgr = {
    tituloReporte: 'DIN Pendientes',
    tituloMenu: 'DIN',
    subtituloReporte: 'Deudas aduaneras vigentes de formularios 15 y 17 en TGR.',
    icono: 'pi pi-file-exclamation',
    anio: false,
    tablas: [{
        datos: 'pendientes',
        titulo: 'DIN Pendientes',
        subtitulo: 'Obligaciones vigentes informadas en Pago Aduana Importadores.',
        columnas: [
            { nombre: 'rutPagado', titulo: 'RUT pagador' },
            { nombre: 'razonSocial', titulo: 'Razón social' },
            { nombre: 'formulario', titulo: 'Formulario' },
            { nombre: 'folio', titulo: 'Folio' },
            { nombre: 'fechaVencimiento', titulo: 'Vencimiento' },
            { nombre: 'totalPagar', titulo: 'Total a pagar', formato: 'moneda', clase: 'text-right' }
        ]
    }]
};

export const TGR_REPORTES_DATOS = {
    tgr_deudas_vencidas: REPORTE_DEUDAS_VIGENTES,
    tgr_convenios_vigentes:REPORTE_CONVENIOS_VIGENTES,
    tgr_din_pendientes: REPORTE_DIN_PENDIENTES,
    tgr_din_pagados: REPORTE_DIN_PAGADOS
} satisfies Record<string, FormatoReporteTgr>;

export type TipoReporteTgr = keyof typeof TGR_REPORTES_DATOS;
